import { render, staticRenderFns } from "./SelectDisease.vue?vue&type=template&id=374bd7a3&scoped=true"
import script from "./SelectDisease.vue?vue&type=script&lang=js"
export * from "./SelectDisease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374bd7a3",
  null
  
)

export default component.exports